import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MapDetailService } from '../../../services/map-detail.service';
@Component({
  selector: 'bike-traffic',
  standalone: true,
  template:`
  <div class="detail collapse {{ state }}" id="bike">
    <div class="card card-body">
      <a (click)="close()" role="button" aria-expanded="false" aria-controls="bike" class="bt-close">
        <span aria-hidden="true" class="close">×</span>
      </a>

      <div class="site-tt">站點資訊</div>
      <div class="ic_tit">
        <div><div class="icon"><img src="/static/images/svg/map_w_ibike.svg" alt=""></div>YouBike 2.0</div>
        <a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset_bk.svg" alt=""></a>
      </div>


      <ul class="box ibike">
        <li class="titbox">
          <div class="s-title"><p>{{ name }}</p></div>
        </li>
        @if (rentBike !== -1 ) {
        <li class="timelist">
          <p class="t-number"><img src="/static/images/svg/ibike-c.svg" alt="">YouBike 2.0</p>
          <div class="time">
                <span class="arrow"></span>
            <p class="site c">{{ rentBike }}</p>
          </div>
        </li>

        <li class="timelist">
          <p class="t-number"><img src="/static/images/svg/ibike-c.svg" alt="">YouBike 2.0E</p>
          <div class="time">
                <span class="arrow"></span>
            <p class="site c">{{ rentBikeE }}</p>
          </div>
        </li>

        <li class="timelist">
          <p class="t-number"><img src="/static/images/svg/ibike-p.svg" alt="">空位</p>
          <div class="time">
                <span class="arrow"></span>
            <p class="site p">{{ returnBike }}</p>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
  `
})


export class BikeTrafficComponent {


  // [ClienteService] 定義服務
  constructor(private mapDetailService: MapDetailService) {
  }


  @Input() name: string = '';
  @Input() stationId: string = '';
  @Output() callBack =  new EventEmitter<void>();
  state:string =""
  rentBike:number = 0 ;
  rentBikeE:number = 0;
  returnBike:number = 0;

  ngOnChanges(){
    this.state = "show";
    if(this.state = "show") {
      this.getTrain();
    }
  }
  close(){
    this.callBack.emit();
  }

  getTrain() {
    this.rentBike = -1;
    this.mapDetailService.getBike(this.stationId).subscribe((bikeObject:any) => {
      this.rentBike = bikeObject.rentBike;
      this.rentBikeE = bikeObject.rentBikeE;
      this.returnBike = bikeObject.returnBike;
    });
  }
}
